import { render, staticRenderFns } from "./luckyWinner.vue?vue&type=template&id=8af31420&"
import script from "./luckyWinner.vue?vue&type=script&lang=js&"
export * from "./luckyWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports